import { Flex, Form, Space, Typography } from 'antd';
import { Cache } from 'aws-amplify';
import classNames from 'classnames';
import { useEffect } from 'react';

import IconLogo from '@/assets/icons/logo.svg?react';
import { REMEMBER_ME_INFO_KEY } from '@/constants/auth.constants';
import { LoginForm } from '@/features/auth/components/forms/login-form';
import { useLogin } from '@/features/auth/mutations';
import { checkIsChainDomain } from '@/helpers/auth.helper';

export function Login() {
  const [form] = Form.useForm();
  const { error, isPending, mutate: login } = useLogin();

  const isChainDomain = checkIsChainDomain();

  useEffect(() => {
    const rememberMeInfo = Cache.getItem(REMEMBER_ME_INFO_KEY);
    form.setFieldsValue(rememberMeInfo);
  }, [form]);

  return (
    <Flex
      vertical
      flex={1}
      className={classNames('page-login', {
        'page-login-chain': isChainDomain,
      })}
    >
      <Space wrap size="middle" className="title-section">
        <IconLogo />
        <Typography.Title level={1}>
          {isChainDomain ? 'ログイン' : 'SUNTORY ログイン'}
        </Typography.Title>
      </Space>
      <LoginForm
        form={form}
        error={error}
        className="form-section"
        isPending={isPending}
        onFinish={login}
      />
    </Flex>
  );
}
